// TODO(add-merch-pills-to-xdp-hero): once the experiment concludes, either:
// - combine this with marketingTagUtils.ts
// - remove this logic (clarify with Brian Curtis / Nida Awadia)

export const GOOGLE_REFRESH_CERTIFICATE_SLUGS: ReadonlyArray<string> = [
  'google-data-analytics',
  'google-digital-marketing-ecommerce',
  'google-it-support',
  'google-project-management',
  'google-ux-design',
  'google-cybersecurity',
];

export const GOOGLE_REFRESH_S12N_SLUGS: ReadonlyArray<string> = ['ai-essentials-google', 'prompting-essentials-google'];

export const IBM_REFRESH_CERTIFICATE_SLUGS: ReadonlyArray<string> = [
  'ibm-data-analyst',
  'ibm-cybersecurity-analyst',
  'ibm-data-engineer',
  'ibm-data-science',
  'ibm-digital-marketing-and-growth-hacking',
  'ibm-full-stack-cloud-developer',
  'ibm-ios-android-mobile-app-developer-pc',
  'java-developer',
  'ibm-program-manager',
  'ibm-relational-database-administrator',
  'ibm-product-owner',
] as const;

export const GOOGLE_REFRESH_COURSE_SLUGS: ReadonlyArray<string> = [
  'prepare-for-cybersecurity-jobs',
  'applying-project-management',
  'ux-design-jobs',
  'satisfaction-guaranteed',
  'it-security',
  'google-data-analytics-capstone',
] as const;

export const shouldShowNewAiSkillsBadge = (slug?: string) => {
  if (!slug) {
    return false;
  }

  return (
    GOOGLE_REFRESH_CERTIFICATE_SLUGS.includes(slug) ||
    GOOGLE_REFRESH_S12N_SLUGS.includes(slug) ||
    IBM_REFRESH_CERTIFICATE_SLUGS.includes(slug)
  );
};

export const shouldShowNewAiSkillsXdpAiSyllabus = (s12nSlug?: string, courseSlug?: string) => {
  if (!s12nSlug || !courseSlug) return false;

  return GOOGLE_REFRESH_COURSE_SLUGS.includes(courseSlug) && shouldShowNewAiSkillsBadge(s12nSlug);
};

export default shouldShowNewAiSkillsBadge;
